import React from 'react';
import { useSelector } from 'react-redux';
import { PaymentMethods } from '../../../../_common/payments2';
import { EndPoints } from '../../../../constants/api-config';


export const SettingsPaiement = () => {
	const user = useSelector(state => state.user);

	return (
		<div className="auto-view h-100 mb-auto pt-3">
			<div className="container-fluid h-xl-inherit">
				<PaymentMethods user={user.user} loadings={user.isLoading} stripeClientSecret={user.stripeClientSecret} />
			</div>
		</div>
	);
};